var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableBoxA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 33,
    viewBox: "0 0 76 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211",
    d: "M75.15 32.85V5.15H75.85V32.85H75.15Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_2",
    d: "M56.15 32.85V1.15H56.85V32.85H56.15Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_3",
    d: "M37.15 32.85V1.15H37.85V32.85H37.15Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_4",
    d: "M20.15 32.85V6.15H20.85V32.85H20.15Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M69.798 0.349854H73.7417V0.849854H75.2136V1.91835H75.7136V5.05533H75.2136V6.62383H73.7417V6.12383H69.798V6.62383H65.8543V6.12383H61.9105V6.62383H57.9668V6.12383H54.0231V6.62383H50.0793V6.12383H46.1356V6.62383H42.1919V6.12383H38.2482V6.62383H34.3044V6.12383H30.3607V6.62383H26.417V6.12383H22.4732V6.62383H18.5295V6.12383H14.5858V6.62383H10.642V6.12383H6.69831V6.62383H2.75458V6.12383H1.28271V5.05533H0.782715V1.91835H1.28271V0.349854H2.75459V0.849854H6.69832V0.349854H10.6421V0.849854H14.5858V0.349854H18.5295V0.849854H22.4732V0.349854H26.417V0.849854H30.3607V0.349854H34.3044V0.849854H38.2482V0.349854H42.1919V0.849854H46.1356V0.349854H50.0793V0.849854H54.0231V0.349854H57.9668V0.849854H61.9105V0.349854H65.8543V0.849854H69.798V0.349854Z",
    fill: "#B2B2BF",
    stroke: "#B2B2BF",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_5",
    d: "M0.911719 12.5362H75.5429V13.7408H0.911719V12.5362Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_6",
    d: "M0.911719 18.5545H75.5429V19.7591H0.911719V18.5545Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_7",
    d: "M0.911719 24.5726H75.5429V25.7772H0.911719V24.5726Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 211_8",
    d: "M0.911719 30.5909H75.5429V31.7955H0.911719V30.5909Z",
    fill: "#B2B2BF",
    stroke: "#F1F1F5",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23999",
    x: 3,
    y: 1.5,
    width: 14,
    height: 4,
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBoxA);
export default __webpack_public_path__ + "static/media/TableBoxA.2ae4f3fff574425f5f8dff990daf1b4c.svg";
export { ForwardRef as ReactComponent };